import { useNavigate } from "react-router-dom";
// import RecordRTC from "recordrtc";

import { Button } from "../../components";
import CameraRight from "./CameraRight";
import MicRight from "./MicRight";
import InstructionRight from "./InstructionRight";
import InternetRight from "./InternetRight";
import { examSetupSteps } from "../../constant/Constants";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ScreenRecordingRight from "./ScreenRecordingRight";

const SetupRight = ({
  step,
  hasCameraPermission,
  hasMicPermission,
  isMicWorking,
  hasInternetConnection,
}) => {
  const navigate = useNavigate();
  const steps = examSetupSteps;

  const handleNext = () => {
    const stpNo = steps?.findIndex((stp) => stp === step);
    navigate(
      steps.length === stpNo + 1
        ? `/assessment/instructions`
        : `/assessment/setup/${steps[stpNo + 1]}`
    );
  };

  const recordingStatus = useSelector(
    (state) => state.screenRecording.recordingStatus
  );

  const [isNextDisabled, setIsNextDisabled] = useState(true);
  useEffect(() => {
    switch (step) {
      case "camera":
        setIsNextDisabled(!hasCameraPermission);
        break;
      case "mic":
        setIsNextDisabled(!isMicWorking || !hasMicPermission);
        break;
      case "internet":
        setIsNextDisabled(!hasInternetConnection);
        break;
      case "screenRecording":
        setIsNextDisabled(recordingStatus !== "recording");
        break;
      default:
        setIsNextDisabled(false);
    }
  }, [
    steps,
    step,
    hasCameraPermission,
    isMicWorking,
    hasMicPermission,
    hasInternetConnection,
    recordingStatus,
  ]);

  return (
    <>
      {step === "camera" && <CameraRight />}
      {step === "mic" && <MicRight />}
      {step === "internet" && <InternetRight />}
      {step === "screenRecording" && <ScreenRecordingRight />}
      {step === "instruction" && <InstructionRight />}

      <div className="ml-[10%]">
        <Button
          version="primary"
          text="Proceed"
          handleClick={handleNext}
          width="fit-content"
          isDisabled={isNextDisabled}
        />
      </div>
    </>
  );
};

export default SetupRight;
